import React, { useEffect, useState } from "react";
import "./ProfileImageComponent.css";
import { useDispatch } from "react-redux";
import { fetchProfileData } from "../../../CentralStore/ExportLMSTable/dataSlice";
import {
  updateUserPhoto,
  getThemeURL,
} from "../../../Services/EndPoints";
import {
  getData,
} from "../../../Services/Services";
import lmsToast from "../../DMS/Common/CustomToastifier/CustomToastifier";
import { useTranslation } from "react-i18next";
import DmsButton from "../../DMS/Common/DmsButton/DmsButton";
import avatar from "../../../Assets/Images/avatar.png";
import { putDataFormDataWithNoidPf } from "../../../Services/ProfileServices";

export default function ProfileImageComponent({ profileData, userData = [] }) {
  const dispatch = useDispatch();
  const [fileObj, setFileObj] = useState(null);
  const [imgSrc, setImgSrc] = useState(avatar);
  const [errorMsg, setErrorMsg] = useState("");
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const { t } = useTranslation();

  const validFileTypes = ["image/png", "image/jpg", "image/jpeg"];

  // Set the initial image source when profileData changes
  useEffect(() => {
    if (profileData?.user_image) {
      // Check if the image is already a data URL or needs to be converted
      if (profileData.user_image.startsWith("data:")) {
        setImgSrc(profileData.user_image);
      } else {
        // Convert base64 string to data URL
        setImgSrc(`data:image/jpeg;base64,${profileData.user_image}`);
      }
    } else {
      setImgSrc(avatar);
    }
  }, [profileData]);

  const updateFormWithData = (res) => {
    if (res && res.data) {
      const updatedUserData = res.data;
      document.getElementById("first_name").value = updatedUserData.first_name;
      document.getElementById("email").value = updatedUserData.email;
    }
  };

  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file && validFileTypes.includes(file.type)) {
      if (file.size < 15000000) {
        setFileObj(file);
        const reader = new FileReader();
        reader.onload = (e) => {
          setImgSrc(e.target.result);
        };
        reader.readAsDataURL(file);
        setIsSaveDisabled(false);
        setErrorMsg("");
      } else {
        setErrorMsg("File size is too large. Please select a smaller image.");
      }
    } else {
      setErrorMsg("Invalid file type. Please select an image (PNG, JPG, JPEG).");
    }
  };

  const handleSave = () => {
    if (!fileObj || !profileData?.id) return;

    const reader = new FileReader();
    reader.readAsDataURL(fileObj);

    reader.onload = async () => {
      // Get the base64 part (remove the data URL prefix)
      const base64String = reader.result.split(",")[1];

      const user_profile = {
        id: profileData.id,
        user_image: base64String, // Send only the base64 part
      };

      const formData = new FormData();
      formData.append("user_profile", JSON.stringify(user_profile));

      try {
        const response = await putDataFormDataWithNoidPf(updateUserPhoto, formData);
        setTimeout(() => {
          lmsToast({ toasterType: "success", operationType: "edit" });
          // Reload the window after showing success toast
          window.location.reload();
        }, 300);
        dispatch(fetchProfileData());
        updateFormWithData(response);
        setIsSaveDisabled(true);
      } catch (error) {
        console.error("Upload error:", error);
        lmsToast({ toasterType: "error", msg: "Upload failed" });
      }
    };

    reader.onerror = (error) => {
      console.error("File reading error:", error);
      lmsToast({ toasterType: "error", msg: "Error processing image" });
    };
  };

  const handleClick = () => {
    const fileInputTriger = document.getElementById("file_upload");
    if (fileInputTriger) {
      fileInputTriger.click();
    }
  };

  return (
    <div className="image_container--maindiv">
      <div className="profile_image">
        <img
          src={imgSrc}
          className="profile_image--image"
          width="100%"
          height="100%"
          onError={(e) => {
            e.target.src = avatar;
          }}
          alt="Profile"
        />
        {errorMsg && <div className="error__message w-100">{errorMsg}</div>}
        <div className="edit-profile_icon">
          <DmsButton label={t("editphoto")} onClick={handleClick} />
          <input
            id="file_upload"
            type="file"
            accept="image/*"
            name="file_upload"
            style={{ display: "none" }}
            onChange={handleChange}
          />
          <DmsButton
            label={t("Save")}
            onClick={handleSave}
            disabled={isSaveDisabled}
            style={{ marginTop: "0px", marginLeft: "1rem" }}
          />
        </div>
        <div className="user-profile_detail">
          <div>
            {`${profileData?.first_name} ${profileData?.middle_name || ""} ${profileData?.last_name}`}
          </div>
          <div>{profileData?.user_name}</div>
          <div>{profileData?.phone_number}</div>
        </div>
      </div>
    </div>
  );
}